/**
 * LobbyService — High-Level-API für Lobby-Aktionen.
 *
 * WARUM eigene Schicht: Screens sollen nicht direkt `socketService.send(...)`
 * aufrufen. Bessere Lesbarkeit + zentraler Punkt für Validierung.
 */
import { socketService } from './socketService.js';
import { eventBus } from '../core/eventBus.js';

class LobbyService {
  constructor() {
    this.currentLobby = null;
    this.playerId = null;

    // Server-Events auf gemeinsamen State spiegeln
    eventBus.on('server:lobby_created', (msg) => {
      this.currentLobby = msg.lobby;
      this.playerId = msg.playerId;
    });
    eventBus.on('server:lobby_updated', (msg) => {
      this.currentLobby = msg.lobby;
      if (msg.playerId) this.playerId = msg.playerId;
    });
    eventBus.on('server:player_joined', (msg) => { this.currentLobby = msg.lobby; });
    eventBus.on('server:player_left',   (msg) => { this.currentLobby = msg.lobby; });
  }

  ensureConnected() {
    if (!socketService.connected) socketService.connect();
  }

  createLobby(playerName) {
    this.ensureConnected();
    // Auf Connect warten, falls noch nicht verbunden
    const send = () => socketService.send('create_lobby', { playerName });
    if (socketService.connected) send();
    else eventBus.on('socket:open', send);
  }

  joinLobby(playerName, lobbyCode) {
    this.ensureConnected();
    const send = () => socketService.send('join_lobby', { playerName, lobbyCode });
    if (socketService.connected) send();
    else eventBus.on('socket:open', send);
  }

  leaveLobby() {
    if (socketService.connected) socketService.send('leave_lobby');
    this.currentLobby = null;
  }

  startGame(rounds = 5) {
    socketService.send('start_game', { rounds });
  }

  submitAnswer(answer, usedHint = false) {
    socketService.send('submit_answer', { answer, usedHint });
  }

  useHint() {
    socketService.send('use_hint');
  }

  isHost() {
    return this.currentLobby && this.currentLobby.hostId === this.playerId;
  }
}

export const lobbyService = new LobbyService();
